import { render, staticRenderFns } from "./modifyInfos.vue?vue&type=template&id=55b3a1c2&scoped=true&"
import script from "./modifyInfos.vue?vue&type=script&lang=js&"
export * from "./modifyInfos.vue?vue&type=script&lang=js&"
import style0 from "./modifyInfos.vue?vue&type=style&index=0&id=55b3a1c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b3a1c2",
  null
  
)

export default component.exports